const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');

class Scratch3SeedsMath {
    constructor (runtime) {
        this.runtime = runtime;
    }

    getInfo () {
        return {
            id: 'seedsMath',
            name: 'Math',
            color1: '#59C059',
            color2: '#46B946',
            blocks: [
                {
                    opcode: 'convertToNumber',
                    blockType: BlockType.REPORTER,
                    text: 'convert [VALUE] to number',
                    arguments: {
                        VALUE: {
                            type: ArgumentType.STRING,
                            defaultValue: '123'
                        }
                    }
                }
            ]
        };
    }

    convertToNumber (args) {
        const num = Number(args.VALUE);
        return isNaN(num) ? 0 : num;
    }
}

module.exports = Scratch3SeedsMath;
